/**
 * Axios client for the Local Bridge base URL (e.g. API_BASE_URL + /local-bridge prefix when proxied).
 * Sends the same Bearer token as apiClient so authenticated routes (e.g. company control-bridge) work.
 */
import axios from 'axios';
import { LOCAL_BRIDGE_API_URL } from '../config';

export function getLocalBridgeApiClient() {
  if (!LOCAL_BRIDGE_API_URL) return null;
  const client = axios.create({
    baseURL: LOCAL_BRIDGE_API_URL,
    timeout: 30000,
    headers: { 'Content-Type': 'application/json' },
  });
  client.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });
  return client;
}

export const localBridgeApiClient = getLocalBridgeApiClient();
